import React, { Fragment } from 'react';
import { Trans } from 'react-i18next';
import { Link } from 'gatsby';

import { Stack } from '../../../atoms/stack/Stack';
import { Typography } from '../../../atoms/typography/Typography';
import { StyledHtmlDiv } from '../../../atoms/styledHtmlDiv/StyledHtmlDiv';

export const InfoSection = ({ section }) => (
  <div
    id={section.linkIdToTextUnder}
    className="flex w-full flex-col flex-1 px-8 lg:mx-auto my-5 max-w-7xl mt-20"
  >
    <div className="flex flex-col md:flex-row flex-1 justify-center py-4 gap-10 md:gap-2">
      <Stack className="gap-4 md:mr-6 max-w-full md:max-w-2xl">
        {section.componentData.map((item) => {
          if (item.title === 'SYSTEMGUIDE') {
            return (
              <div key={item.title} className="my-10">
                <p>
                  <b>
                    <Trans i18nKey="category.text.systemguide">
                      Do you want to compare different systems right now?
                      Welcome to visit the
                      <Link
                        to={section.categoryGuideUrl}
                        className="text-primary-500"
                      >
                        BusinessWith system guide
                      </Link>
                      .
                    </Trans>
                  </b>
                </p>
              </div>
            );
          }

          return (
            <Fragment key={item.title}>
              {item.label && (
                <Typography
                  textAlign="left"
                  fontVariant="h8"
                  className="!text-secondary-400"
                >
                  {item.label}
                </Typography>
              )}
              <Typography as="h2" textAlign="left" fontVariant="h4">
                {item.title}
              </Typography>
              <StyledHtmlDiv
                className="text-clamp-lg font-light normal-case text-left !text-customGray-600"
                content={item.text}
              />
            </Fragment>
          );
        })}
      </Stack>
    </div>
  </div>
);
